import * as React from 'react'
import classnames from 'classnames'
import { Props } from './types'
// @ts-ignore
import './styles.scss'

class StepBar extends React.Component<Props> {
  get currentProgress() {
    const {
      currentStep,
      data,
    } = this.props

    const step: number = currentStep
    const total: number = data.length - 1

    if (total <= 0 || total <= step) {
      return 100
    }

    const progress = step / total * 100

    if (progress === 0) {
      return 1
    }

    return progress
  }

  render(): JSX.Element | null {
    const {
      data,
      handleChangeStep,
      currentStep,
    } = this.props

    if (data?.length > 0) {
      return (
        <div className="stepBar">
          <div className="stepBar__bar">
            <div className="fillBar" style={{ width: `${this.currentProgress}%` }} />
          </div>
          <div className="stepBar__label">
            {data.map((value, index) => (
              <button
                key={value?.name}
                type="button"
                className={classnames('stepBar__label__item', {
                  ['stepBar__label__item--is-active']: index === currentStep,
                })}
                onClick={() => handleChangeStep(index)}>
                <p>{value?.name}</p>
              </button>
            ))}
          </div>
        </div>
      )
    }

    return null
  }
}

export default StepBar
